<script setup lang="ts">
const { t } = useI18n()
</script>

<template>
  <UCard
    class="gradient-texture flex flex-col"
    :ui="{
      body: {
        base: '!p-0',
      },
    }"
  >
    <template #header>
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-2">
          <UIcon
            class="text-lg text-gray-500 md:text-xl dark:text-gray-400"
            :name="getIcon('analytics')"
          />

          <h2 class="text-lg font-bold">
            {{ t('title') }}
          </h2>
        </div>
      </div>
    </template>

    <div class="flex h-full flex-1 items-center justify-center">
      <ApiUsageBox />
    </div>
  </UCard>
</template>

<i18n lang="json">
{
  "en": {
    "title": "API Usage"
  },
  "es": {
    "title": "Uso de API"
  },
  "fr": {
    "title": "Utilisation de l'API"
  }
}
</i18n>
